const Statuses = {
    0: {
        type: 'active',
        displayedName: 'Active',
    },
    4: {
        type: 'processing',
        displayedName: 'Processing',
        toolTip: 'Pending Update',
    },
    5: {
        type: 'processing',
        displayedName: 'Processing',
        toolTip: 'Pending Allocation',
    },
    6: {
        type: 'processing',
        displayedName: 'Processing',
        toolTip: 'Pending Deallocation',
    },
    7: {
        type: 'action',
        displayedName: 'Action Required',
        toolTip: 'Pending Action',
    },
    14: {
        type: 'updateAcknowledgement',
        displayedName: 'Processing',
        toolTip: 'Pending Acknowledgement',
    },
    17: {
        type: 'requiredAcknowledgement',
        displayedName: 'Confirm',
        toolTip: 'Confirm Transfer',
    },
    20: { type: 'error', displayedName: 'Error' },
    disabled: {
        type: 'disabled',
        displayedName: 'Disabled',
    },
};

export default Statuses;
